import { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';

export interface EmptyListProps {
  message: string;
  action?: ReactNode;
}

/**
 * Component to display when a list is empty with an optional action button
 *
 * @example
 * <EmptyList
 *   message="This group has no machines associated."
 *   action={<AddMachineButton onSuccess={refresh} />}
 * />
 */
export const EmptyList = ({ message, action }: EmptyListProps) => {
  return (
    <>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        {message}
      </Typography>
      {action && <Box sx={{ textAlign: 'right' }}>{action}</Box>}
    </>
  );
};
